import { InvoiceResumeDriverDetails } from '@allocab/allocab-driver-shared-types';
import { useMemo } from 'react';

import { DriverAmountCalc } from './DriverAmoutCalc';
import { Link } from '../../components/atomic/Link';
import { Table } from '../../components/table/Table';
import { TableColumn } from '../../components/table/types';
import { useDriverOptions } from '../../services/driver-options/useDriverOptions';
import { t } from '../../services/translation/translation';

type Context = {
  isSubjectToVAT: boolean;
};

const columns: TableColumn<InvoiceResumeDriverDetails, Context>[] = [
  {
    name: t('common.name'),
    render: resume => <Link to={`/drivers/${resume.driverKey}`}>{resume.driverName}</Link>,
  },
  {
    name: t('common.nb-trips'),
    render: resume => resume.nbFares,
  },
  {
    // Montant BRUT - Total encaissé à bord - Commissions et abonnements = Montant NET/{{options}}
    name: context => (
      <p>
        <span className="text-pink-400">{t('invoicing-route.gross-amount')}</span>
        {' - '}
        <span className="text-blue-400">{t('invoicing-route.onboard-total')}</span>
        {' - '}
        <span className="text-orange-400">{t('invoicing-route.commission')}</span>
        {' = '}
        <span className="text-green-400">{t('invoicing-route.net-amount')}</span>
        {` ${context.isSubjectToVAT ? t('common.ttc') : t('common.ht')}`}
      </p>
    ),
    render: driverDetails => <DriverAmountCalc driverDetails={driverDetails} />,
  },
];

type Props = {
  data: InvoiceResumeDriverDetails[];
  isLoading: boolean;
  isFetching: boolean;
};

export const TurnoverByDriverTable = ({ data, isLoading, isFetching }: Props) => {
  const { driverOptions } = useDriverOptions();
  const filteredData = useMemo(
    () =>
      data
        .filter(d => d.benefits !== 0)
        .sort((a, b) => (a.driverName > b.driverName ? 1 : -1))
        .map(d => ({ ...d, id: d.driverKey })),
    [data],
  );

  if (filteredData.length === 0) {
    return null;
  }

  return (
    <Table
      identifier="id"
      columns={columns}
      data={filteredData}
      isLoading={isLoading}
      isFetching={isFetching}
      title={t('invoicing-route.income-by-drivers')}
      context={{ isSubjectToVAT: driverOptions.isSubjectToVAT }}
      totalItems={filteredData.length}
    />
  );
};
